import React from 'react';
import { createPortal } from 'react-dom';
import { CalendarIcon, ChevronDownIcon } from '../icons';
import DateInput from './DateInput';

/**
 * StartDateDropdown Component
 * Dropdown for setting start date of selected missions
 */
const StartDateDropdown = ({
  isActive,
  onToggle,
  onStartDateChange,
  menuStyle,
  buttonRef,
}) => {
  return (
    <div className="bulk-actions-toolbar__dropdown-container">
      <button
        ref={buttonRef}
        className={`bulk-actions-toolbar__btn ${isActive ? 'bulk-actions-toolbar__btn--active' : ''}`}
        onClick={(e) => onToggle('startDate', e.currentTarget)}
        title="Set start date"
      >
        <CalendarIcon />
        <span>Start</span>
        <ChevronDownIcon />
      </button>
      {isActive && createPortal(
        <div className="bulk-actions-toolbar__menu bulk-actions-toolbar__menu--date" style={menuStyle}>
          <DateInput
            onChange={onStartDateChange}
            presets={[
              { label: 'Clear start date', value: null },
              { label: 'Today', value: 0 },
              { label: 'Tomorrow', value: 1 },
              { label: 'Next week', value: 7 },
            ]}
          />
        </div>,
        document.body
      )}
    </div>
  );
};

export default StartDateDropdown;
